import React, {Component} from "react";
import Modal from "../../../shared/component/model/Modal";
import logo from "../../../assets/images/logo.svg";
import T from "../../../shared/component/t/T";
import TextBox from "../../../shared/component/textbox/Textbox";
import Button from "../../../shared/component/button/Button";
import Login from "../../../core/api/user/Login";
import Validation from "../../../helpers/Validation";
import Storage from "../../../helpers/Storage";
import { connect } from "react-redux";
import { _alert } from "../../../actions/Alert";
import {handleChangeDirection, handleChangeLang} from "../../../actions/Lang";
import {handleChangeCalendar} from "../../../actions/Calendar";
import {handleChangeDoubleClickAction} from "../../../actions/UserSettings";
import snippets from "../../../helpers/snippets";

const login = new Login();

class SigninModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorData: {counter: 0, errors: [], hints:[]},
            username: "",
            password: "",
            serverLoginErrors: [],
        };
    }

    #closeModal = () => {
        this.props.closeHandler();
    }

    #loginSucceed = () => {
        if(this.props?.loginSucceed){
            return this.props?.loginSucceed?.()
        }
        this.#closeModal();
    }

    handleInput = (event) => {
        let someProperty = this.state.errorData
        someProperty.counter = Math.max(0, someProperty.counter-1)
        someProperty.errors[event.target.name] = ""
        someProperty.hints[event.target.name] = ""
        this.setState({
            [event.target.name]: event.target.value,
            errorData: someProperty,
            serverLoginErrors: [],
        });
    }

    loginAgain = (event) => {

        let errors = {
            username: '',
            password: ''
        };
        let hints = {
            username: '',
            password: ''
        };

        const validators = {
            username: ['required'],
            password: ['required'],
        };

        const userInput = {
            username: this.state.username,
            password: this.state.password
        };

        const validationResult = Validation.validate(userInput, errors, hints, validators);
        this.setState({
            errorData: {'counter': validationResult.errorCount, 'errors': validationResult.errors, 'hints': validationResult.hints}
        });

        if (!validationResult.errorCount) {
            login.into(userInput).then((response) => {
                Storage.setNewLogin(response);
                this.props.dispatch(_alert(true, 'success', response.data.message));
                this.props.dispatch(handleChangeLang(response.data.configs.general.language));
                this.props.dispatch(handleChangeDirection(response.data?.configs?.general?.direction));
                this.props.dispatch(handleChangeCalendar(response.data.configs.general.calendar));
                this.props.dispatch(handleChangeDoubleClickAction(response.data.configs.general.doubleClickAction));
                this.#loginSucceed();
            }).catch(error => {
                this.setState({
                    serverLoginErrors: [error?.response?.data?.msg]
                });
            });
        }
    }

    render() {
        const {modalTitle = "", closable= false} = this.props;

        return <Modal closeHandler={this.#closeModal} logo={logo} title={modalTitle} description={<T token={'enter_login'}/>} closable={closable}>
            <TextBox changeValue={this.handleInput}
                        errorData={this.state.errorData}
                        name="username"
                        placeholder={''}
                        showMessage={true}
                        showLabel={true}
                        label={<T token={'username'}/>}
            />
            <TextBox changeValue={this.handleInput}
                        errorData={this.state.errorData}
                        name="password"
                        type="password"
                        showMessage={true}
                        showLabel={true}
                        label={<T token={'password'}/>}
            />

            {!snippets.isObjectEmpty(this.state.serverLoginErrors) &&
                <div className={'sign__serverError'}>
                    {this.state.serverLoginErrors}
                </div>
            }
            <Button type="submit" mode="warning" onClick={this.loginAgain}>
                <T token={'login'}/>
            </Button>
        </Modal>;
    }
}

export default connect()(SigninModal);

// Created at 2022/11(November)/09(Wednesday)
